<template>
  <div class="user-list">
    <el-tabs v-model="searchParam.status" type="card" @tab-click="getList">
      <el-tab-pane label="上架" name="2"></el-tab-pane>
      <el-tab-pane label="下架" name="1"></el-tab-pane>
    </el-tabs>
    <div class="search-bar flex">
      <div class="left">
        <el-input v-model="searchParam.keyword_search" placeholder="输入名称" clearable @clear="getList"></el-input>
        <el-select v-model="searchParam.cate_uuid" clearable placeholder="请选择分类" @clear="getList">
          <el-option v-for="(item, index) in classList" :key="index" :label="item.title" :value="item.uuid">
          </el-option>
        </el-select>

        <el-button type="primary" @click="getList('clear')">查询</el-button>
      </div>
      <div class="right">
        <el-button type="primary" @click="toDetail()">新增 </el-button>
      </div>
    </div>
    <div class="table">
      <el-table v-loading="loading" :data="tableData" border style="width: 100%">
        <el-table-column prop="imgUpload" label="商品图片" width="120px">
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px"
              :src="scope.row.thumb"
              fit="contain"
              :preview-src-list="[scope.row.thumb]"
            >
            </el-image> </template
        ></el-table-column>
        <el-table-column prop="title" label="商品名称" width="120px"> </el-table-column>

        <el-table-column prop="cate_uuid" label="分类" width="120px">
          <template slot-scope="scope">
            {{ getClassName(scope.row.cate_uuid) }}
          </template>
        </el-table-column>
        <el-table-column prop="price" label="价格" width="160"></el-table-column>
        <el-table-column prop="stock" label="库存"> </el-table-column>

        <el-table-column prop="sale" label="销量"> </el-table-column>

        <el-table-column prop="create_time" label="创建时间" width="160"> </el-table-column>
        <el-table-column label="操作" fixed="right" width="280">
          <template slot-scope="scope">
            <el-button class="mid-blue" @click="toDetail(scope.row)">编辑</el-button>

            <el-button class="mid-blue" @click="xiajia(scope.row)">{{
              scope.row.status == 2 ? "下架" : "上架"
            }}</el-button>
            <el-button class="mid-red" @click="deleteItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page="page_index"
          :page-sizes="[10, 20, 60, 100]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mixin } from "@/mixins/pagination.js";
import { getCate, getGood, deleteGood, GoodStatus } from "@/api/product.js";
export default {
  mixins: [mixin],
  data() {
    return {
      loading: false,
      classList: [],
      teacherList: [],
      searchParam: {
        keyword_search: "",
        status: "2",
      },
      tableData: [],
    };
  },
  mounted() {
    this.getList();
    this.getClassList("");
  },
  methods: {
    getClassName(uuid) {
      const item = this.classList.find((it) => {
        return it.uuid == uuid;
      });
      if (item) {
        return item.title;
      }
    },
    async getClassList() {
      const res = await getCate({ status: 2 });
      if (res.data instanceof Array) {
        this.classList = res.data;
      }
    },
    toDetail(row) {
      console.log(row);
      this.$router.push({
        path: "/product-add",
        query: row,
      });
    },

    setTop(row) {
      setTopLive(row.uuid).then((res) => {
        if (res) {
          this.$message.success("成功");
          this.getList();
        }
      });
    },
    xiajia(row) {
      GoodStatus(row.uuid).then((res) => {
        if (res) {
          this.$message.success("成功");
          this.getList();
        }
      });
    },
    deleteItem(row) {
      this.$confirm("确定要删除该商品吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteGood(row.uuid).then((res) => {
            if (res) {
              this.$message.success("成功");
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async getList() {
      const param = {
        page_index: this.page_index,
        page_size: this.page_size,
        ...this.searchParam,
      };
      this.loading = true;
      const res = await getGood(param);
      this.loading = false;
      if (res.data instanceof Array) {
        this.tableData = res.data;
        this.total = res.total;
      }
    },
  },
};
</script>

<style scoped="scoped">
.user-list {
  background: white;
  padding: 10px;
  box-sizing: border-box;
}
</style>
